var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['slider-arrow', ("slider-arrow--" + _vm.direction), { 'slider-arrow--small': _vm.isSmall }]})}
var staticRenderFns = []

export { render, staticRenderFns }